import React from 'react';
import styled from 'styled-components';

import Video from './sections/Video';
import InvestInAmazing from './sections/InvestInAmazing';
import Stories from './sections/Stories';
import Register from './sections/Register';
import vw from 'src/styles/utils';
import Header from 'components/Header';
// import Instagram from './sections/Instagram';
import Footer from 'components/Footer';

const Home = () => {
  return (
    <Root>
      <Header />
      <Hero src={require('src/assets/images/hero.jpg')} alt="ig" />
      <InvestInAmazing />
      <Video />
      <Stories />
      <Register />
      <img src={require('src/assets/images/ig-strip.jpg')} alt="ig" />
      {/* <Instagram /> */}
      <Footer />
    </Root>
  );
};

const Root = styled.main`
  > img {
    width: 100%;
    height: auto;
  }
`;
const Hero = styled.img`

  ${vw('padding-top', 85, 110, 40)}
`
export default Home;
